import { render, staticRenderFns } from "./InfoPago.vue?vue&type=template&id=6fe45c5a"
import script from "./InfoPago.vue?vue&type=script&lang=js"
export * from "./InfoPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports